// src/components/LabeledSwitchWithHint.jsx
import { FormControlLabel, Switch, Tooltip, IconButton, Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useUi } from "../context/UiContext";

export default function LabeledSwitchWithHint({
  checked,
  onChange,
  label,
  hint,
  disabled,
  sx,
}) {
  const { showTooltips } = useUi();

  const showHint = showTooltips && Boolean(hint);

  return (
    <Box display="flex" alignItems="center" gap={1} sx={sx}>
      <FormControlLabel
        control={<Switch checked={checked} onChange={onChange} disabled={disabled} />}
        label={label}
      />

      {/* ✅ Tooltip + icon only when enabled */}
      {showHint && (
        <Tooltip title={hint} arrow>
          <IconButton
            size="small"
            onClick={(e) => e.stopPropagation()} // prevents weird toggling when clicking icon
            sx={{ opacity: 0.8, "&:hover": { opacity: 1 } }}
          >
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}
